import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

import { StateContext } from "../../contexts/state.context";
import { runLogout } from "../../utils/services";
import Generate from "./Generate/Generate";
import Search from "./Search/Search";
import styles from "./Licence.module.scss";

const Licence = () => {
	const { currentSession, setCurrentSession } = useContext(StateContext);
	const [activeTab, setActiveTab] = useState("consulta");
	const [logoutError, setLogoutError] = useState("");
	const [isLoggingOut, setIsLoggingOut] = useState(false);
	const navigate = useNavigate();
	const currentUsername = currentSession?.username || "";

	const isMissingSessionCookieError = (error) => {
		const errorBody = error?.body || error?.data || {};
		const errorList = Array.isArray(errorBody?.error)
			? errorBody.error
			: Array.isArray(errorBody)
				? errorBody
				: [];

		return (
			error?.code === "LRG002" &&
			errorList.some((item) =>
				String(item?.msg || item?.message || "").includes(
					"sessionId(cookie)",
				),
			)
		);
	};

	const handleLogout = async () => {
		setLogoutError("");
		setIsLoggingOut(true);

		try {
			const response = await runLogout();
			const responseCode = response?.code || response?.codigo || response;

			if (responseCode === "LRG001" || responseCode) {
				setCurrentSession(null);
				navigate("/admin-login");
				return;
			}

			setLogoutError("No se pudo cerrar la sesion. Intentelo nuevamente.");
		} catch (error) {
			if (error?.code === "LRL008" || isMissingSessionCookieError(error)) {
				setCurrentSession(null);
				navigate("/admin-login", { replace: true });
				return;
			}

			setLogoutError("No se pudo cerrar la sesion. Intentelo nuevamente.");
		} finally {
			setIsLoggingOut(false);
		}
	};

	return (
		<div className={styles.dashboardContainer}>
			<header className={styles.topBar}>
				<div className={styles.topBarContent}>
					<button
						type="button"
						className={styles.userBtn}
						onClick={() => navigate("/profile")}
						aria-label="Perfil de usuario"
					>
						<span className={styles.userIcon}>U</span>
						<span className={styles.userLabel}>
							{currentUsername || "Usuario"}
						</span>
					</button>

					<div
						className={`${styles.logoutErrorBox} ${
							logoutError ? styles.logoutErrorBoxVisible : ""
						}`}
						role="alert"
						aria-live="polite"
					>
						{logoutError}
					</div>

					<button
						type="button"
						className={styles.logoutBtn}
						onClick={handleLogout}
						disabled={isLoggingOut}
					>
						{isLoggingOut ? "Cerrando..." : "Cerrar sesion"}
					</button>
				</div>
			</header>

			<nav className={styles.navSection}>
				<div className={styles.tabsWrapper}>
					<button
						type="button"
						className={`${styles.tabItem} ${
							activeTab === "consulta" ? styles.tabActive : ""
						}`}
						onClick={() => setActiveTab("consulta")}
					>
						Consulta
					</button>
					<button
						type="button"
						className={`${styles.tabItem} ${
							activeTab === "registro" ? styles.tabActive : ""
						}`}
						onClick={() => setActiveTab("registro")}
					>
						Registro
					</button>
				</div>
			</nav>

			<main className={styles.mainContent}>
				<div className={styles.contentCard}>
					{activeTab === "consulta" ? <Search /> : <Generate />}
				</div>
			</main>
		</div>
	);
};

export default Licence;
